import { render, staticRenderFns } from "./CashLending.vue?vue&type=template&id=c4b3e63c&scoped=true&"
import script from "./CashLending.vue?vue&type=script&lang=js&"
export * from "./CashLending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b3e63c",
  null
  
)

export default component.exports